
import Vue from 'vue';
import { newClient } from './axios-client-new';
import { newClient as newClientOld } from './axios-client-old';
import { get } from '@/util';
import { Dialog } from 'vant';
import {getAppName} from "../util";
let appName = getAppName();
// 获取当前地区
export const getCountryListAjax = function(language){
  return newClientOld().post('/web/h5/getCountryList?language='+language)
}


// 获取当前地区
export const getPayChannelsAjax = function(params){
  return newClientOld().get('/web/h5/getPayChannels',{params:params})
}
// 创建订单
export const createOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClientOld().post('/web/h5/pay/createOrder?param='+encodeURIComponent(JSON.stringify(newJson)));
  await  handleFirstPayAfter(payResult);
  return payResult;


}

// pagSmile支付方式

export const pagSmileCreateOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await  newClient().post('/api/h5/token/trade/pagSmile/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)));
  await  handleFirstPayAfter(payResult);
  return payResult;
}

// payssion支付方式
export const payssionCreateOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  const payResult = await newClient().post('/api/h5/token/trade/payssion/payIn/sendPay',newJson);
  await  handleFirstPayAfter(payResult);
  return payResult;
}

// dlocal 支付方式
export const dlocalCreateOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dlocal/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)));
  await  handleFirstPayAfter(payResult);
  return payResult;

}


// 订单处理后首充
async function handleFirstPayAfter(payResult){

  // 风险值过高
  let message;
  if(get(payResult, 'data.data.payUrl')  == -1 || get(payResult, 'result.payUrl') == -1) {
    message = window.rootApp.$t('m.pay_fail_system_risk')  + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(get(payResult, 'data.data.payUrl')  == -2 || get(payResult, 'result.payUrl') == -2) {
    message = window.rootApp.$t('m.paystyle_unavailabel_change_other') + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(message){
    Dialog.alert({
      message: message,
      confirmButtonText: 'OK'
    });
    return Promise.reject('error payIndex')
  }
}


// dukPay 支付方式
export const dukPayCreateOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dukPay/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)));
  await  handleFirstPayAfter(payResult);
  return payResult;
}
// CodaPay 支付方式
export const codaPayCreateOrderAjax = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/coda/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)));
  await  handleFirstPayAfter(payResult);
  return payResult;
}

/**
 * peymentWall-paypal充值方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentWallPaypalCreateOrder = async function(params){
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/paymentWallPayPal/payIn/sendPay', newJson);
  await  handleFirstPayAfter(payResult);
  return payResult;
}



// WEBPACK FOOTER //
// ./src/api/pay.js